































































import {Component, Prop, Emit, Vue} from 'vue-property-decorator';
import CallVerification from "@/consoleapi/api/call_verification";

@Component
export default class RegisterConfirm extends Vue {
    @Prop() public phoneNumber!: string;
    @Prop() public RequestId!: string;

    private service = '';
    private from = '';
    private body = 'プラスコムへの、ご登録、ありがとうございます。認証コードは、{code}となります。繰り返します。コードは、{code}となります。';
    private channel = '';
    private language = '';
    private accountSid = '';

    mounted(): void {
        this.service = String(process.env.VUE_APP_REST_API_2FA_SERVICE);
        this.from = String(process.env.VUE_APP_REST_API_2FA_FROM);
        this.channel = String(process.env.VUE_APP_REST_API_2FA_CHANNEL);
        this.language = String(process.env.VUE_APP_REST_API_2FA_LANGUAGE);
        this.accountSid = String(process.env.VUE_APP_REST_API_2FA_ACCOUNT_SID);
        this.inputConfirmEmit(false);
    }

    @Emit()
    public inputPhoneNumberEmit(inputPhoneNumber: string) {
        inputPhoneNumber
    }

    @Emit()
    public inputConfirmEmit(inputConfirm: boolean) {
        inputConfirm;
    }

    @Emit()
    public inputRequestIdEmit(inputRequestId: string) {
        // console.log(inputRequestId);
    }

    private get inputPhoneNumber(): string {
        return this.phoneNumber;
    }

    private set inputPhoneNumber(phoneNumber: string) {
        this.inputPhoneNumberEmit(phoneNumber);
    }

    private get inputRequestId(): string {
        return this.phoneNumber;
    }

    private set inputRequestId(requestId: string) {
        this.inputRequestIdEmit(requestId);
    }

    private call() {
        const callVerification = new CallVerification();
        callVerification.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
        callVerification.send(
            this.$cookies.get(String(process.env.VUE_APP_COOKIE_COGNITO_USER_NAME)),
            this.service,
            this.from,
            this.replacePhoneNumber(this.phoneNumber),
            this.body,
            this.channel,
            this.language,
            this.accountSid
        ).then(response => {
            // console.log(response.data);
            this.inputRequestIdEmit(response.data.requestID);
            this.inputConfirmEmit(true);
        }).catch(error => {
            // console.log(error.response);
            alert('発信に失敗しました。');
            return;
        })
    }

    private replacePhoneNumber(number: string){
        return number;
        // return number.replace(/^0/, '+81');
    }
}
